__turbopack_context__.v({
  "inactive": "selectFieldFormik-module-scss-module__ZLXSOa__inactive",
  "size-medium": "selectFieldFormik-module-scss-module__ZLXSOa__size-medium",
  "size-small": "selectFieldFormik-module-scss-module__ZLXSOa__size-small",
  "size-tiny": "selectFieldFormik-module-scss-module__ZLXSOa__size-tiny",
});
